import { z } from 'zod';

import { TENANT_DOMAIN_PATTERN } from '../constants/analytics-property.constants';

export const analyticsBasePropertiesSchema = z.object({
  tenant_domain: z.string().regex(TENANT_DOMAIN_PATTERN),
});
